import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerLeafCollectionReportRTF } from './Pages';

export const CustomerLeafCollectionReportRTFRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerLeafCollectionReportRTF} />
       
    </Fragment>
)